interface Route<T> {
  INTEGRATIONS: {
    Azure: {
      [key: string]: T
    },
  },
}

const AzureRoutes: Route<{ index: string }> = {
  INTEGRATIONS: {
    Azure: {
      ACTIVITYAPI: {
        index: '/integrations/azure',
      },
    },
  },
};

const ApiRoutes: Route<string> = {
  INTEGRATIONS: {
    Azure: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/azure_logs/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/azure_logs/checkCredentials',

    },
  },
};

const DocsRoutes: Route<string> = {
  INTEGRATIONS: {
    Azure: {
      GRAYLOG_Azure_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_azure_ActivityLog_Input.html#graylog-azure-activitylog-input',
    },
  },
};

export default AzureRoutes;

export { DocsRoutes, ApiRoutes };
